import { render, staticRenderFns } from "./SellersTable.vue?vue&type=template&id=54798fe4&scoped=true&"
import script from "./SellersTable.vue?vue&type=script&lang=js&"
export * from "./SellersTable.vue?vue&type=script&lang=js&"
import style0 from "./SellersTable.vue?vue&type=style&index=0&id=54798fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54798fe4",
  null
  
)

export default component.exports